import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ILoginTokens, ILoginUser } from "../types/auth";

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  user: ILoginUser | null;
}

const initialState: AuthState = {
  token: localStorage.getItem("@serial") || null,
  isAuthenticated: false,
  user: null,
};

export const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<ILoginTokens>) => {
      state.isAuthenticated = true;
      state.token = action.payload.access_token;
    },
    setUser: (state, action: PayloadAction<ILoginUser>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuth, setUser } = auth.actions;

export default auth.reducer;